import { useEffect, useRef, useState } from 'react';

/**
 * Detects when a "hero" element scrolls out of view.
 * Returns a ref to attach to the hero element and a boolean
 * that becomes true once the hero is no longer visible.
 */
export function useHeroScrolled<T extends HTMLElement = HTMLDivElement>() {
  const heroRef = useRef<T>(null);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const hero = heroRef.current;
    if (!hero) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsScrolled(!entry.isIntersecting);
      },
      { threshold: 0, rootMargin: '-1px 0px 0px 0px' },
    );
    observer.observe(hero);
    return () => observer.disconnect();
  }, []);

  return [heroRef, isScrolled] as const;
}
